export default (date) => {
  const hours = (date.getHours() < 10 ? '0' : '') + date.getHours();

  const minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
  const nearestTen = Math.floor(minutes / 10) * 10;

  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${hours}:${nearestTen}:00`;
};
